<template>
  <b-modal
    id="modal-blocked-security"
    hide-footer
    centered
    :noCloseOnBackdrop="true"
    :noCloseOnEsc="true"
    :hideHeaderClose="true"
  >
    <div class="col-12 d-flex flex-column align-items-center modalsTables">
      <img
        class="centerImg1"
        src="@/assets/images/icons/close.svg"
        width="20%"
      />
      <h3 class="pt-5 font-weight-bold">¡Usuario bloqueado!</h3>
      <p class="pt-5">
        El usuario ha sido bloqueado temporalmente. Por favor, comunicate con el
        administrador
      </p>
    </div>
  </b-modal>
</template>

<script>
export default {};
</script>
<style lang="scss" scoped></style>
